import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BoobleModalService } from 'booble-modal';

import { countries } from 'src/app/shared/utils/countries';
import { GenerateInvoiceDto } from 'src/app/domain/models/dto/generate-invoice.dto';
import { CountryDto } from 'src/app/domain/models/dto/country.dto';
import { AuthenticationService } from 'src/app/shared/services';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { NewOrderModalComponent } from '../new-order-modal/new-order-modal.component';
import { CorporateAccountService } from 'src/app/shared/services/corporate-account.service';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
import { BankAccountDto } from 'src/app/domain/models/dto/bank-account.dto';
import { FinalitiesService } from 'src/app/shared/services/finalities.service';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';

import { CorporateAccountDto } from 'src/app/domain/models/dto/corporate-account.dto';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { GenerateInvoiceSuccessModalComponent } from 'src/app/pages/orders/shared/components/modals/generate-invoice-success-modal/generate-invoice-success-modal.component';


declare const $: any;

@Component({
  selector: 'app-generate-invoice-modal',
  templateUrl: './generate-invoice-modal.component.html',
  styleUrls: ['./generate-invoice-modal.component.scss'],
})
export class GenerateInvoiceModalComponent implements OnInit {
  public loading: boolean;
  companyId: number;
  company: CorporateAccountDto;
  bankAccounts: BankAccountDto[];
  branchs: string[];
  countries: CountryDto[];
  finalities: FinalitiesDto[];
  private readonly notifier: NotifierService;
  orderForm: FormGroup;
  controlBranch: string = '.js-control-branch';
  controlCurrency: string = '.js-control-currency';
  controlAccount: string = '.js-control-account';
  controlCountry: string = '.js-control-country';
  controlFinality: string = '.js-control-finality';
  moedas = Moedas;

  get orderFormControl() {
    return this.orderForm.controls;
  }

  get order(): any {
    const order = this.orderForm.value;
    return order;
  }

  constructor(
    private fb: FormBuilder,
    private readonly router: Router,
    notifierService: NotifierService,
    private readonly route: ActivatedRoute,
    private readonly ordersService: OrdersService,
    private readonly bankAccountService: BankAccountService,
    private readonly finalitiesService: FinalitiesService,
    private readonly companyService: CorporateAccountService,
    private readonly authService: AuthenticationService,
    private modalService: BoobleModalService
  ) {
    this.countries = countries;
    this.companyId = +this.authService.getCompanyId();
    this.notifier = notifierService;
    this.orderForm = fb.group({
      description: ['', Validators.required],
      currency: ['', Validators.required],
      amount: ['', Validators.required],
      corporateAccountId: ['', Validators.required],
      finalityId: [null, Validators.required],
      invoiceReceiverLogo: [false, Validators.required],
      companyName: ['', Validators.required],
      country: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      favorite: [false, Validators.required],
      copyinvoiceemail: [false, Validators.required],
      branch: ['', Validators.required],
      account: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.orderForm.controls['corporateAccountId'].patchValue(this.companyId);
    this.setControls();

    this.companyService.get().subscribe((getResult) => {
      this.company = getResult.data;
      this.bankAccounts = [getResult.data.bankAccount];
      this.orderForm.controls['account'].patchValue(this.bankAccounts[0].number);
      this.branchs = [getResult.data.cnpj];
      this.orderForm.controls['branch'].patchValue(getResult.data.cnpj);
    });

    this.finalitiesService.get().subscribe((getResult) => {
      this.finalities = getResult.data;
    });
  }

  setControls() {
    $(this.controlBranch).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });
    $(this.controlCurrency).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });
    $(this.controlAccount).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });
    $(this.controlCountry).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });
    $(this.controlFinality).select2({
      language: {
        noResults: function () {
          return "Sem resultados";
        }
      }
    });

    let t = this;
    $(this.controlBranch).on('change', function () {
      t.changeBranchForm($(this).val());
    });
    $(this.controlCurrency).on('change', function () {
      t.changeCurrencyForm($(this).val());
    });
    $(this.controlAccount).on('change', function () {
      t.changeAccountForm($(this).val());
    });
    $(this.controlCountry).on('change', function () {
      t.changeCountryForm($(this).val());
    });
    $(this.controlFinality).on('change', function () {
      t.changeFinalityForm($(this).val());
    });
  }

  changeBranchForm(text: String) {
    this.orderForm.controls['branch'].patchValue(text);
  }

  changeCurrencyForm(text: String) {
    this.orderForm.controls['currency'].patchValue(text);
  }

  changeAccountForm(text: String) {
    this.orderForm.controls['account'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
  }

  changeEmailForm() {
    this.orderForm.controls['email'].patchValue(this.orderForm.controls['email'].value.trim())
  }

  changeCountryForm(text: String) {
    this.orderForm.controls['country'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
  }

  changeFinalityForm(text: String) {
    this.orderForm.controls['finalityId'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
  }

  handleCopyinvoiceemail(e) {
    this.orderForm.controls['copyinvoiceemail'].patchValue(e.target.checked);
  }

  sendInvoice() {
    this.loading = true;
    let order: GenerateInvoiceDto = {
      id: this.order.id,
      description: this.order.description,
      currency: this.order.currency,
      amount: this.order.amount,
      finalityId: this.order.finalityId,
      invoiceReceiverLogo: this.order.invoiceReceiverLogo,
      corporateAccountId: this.order.corporateAccountId,
      sender: {
        companyName: this.order.companyName,
        country: this.order.country,
        email: this.order.email,
        favorite: this.order.favorite,
        copyinvoiceemail: this.order.copyinvoiceemail,
      },
      receiver: {
        branch: this.order.branch,
        account: this.order.account,
      },
    };

    this.ordersService.createInboundOrder(order).subscribe({
      next: (orderResult) => {
        this.notifier.notify('success', 'Invoice criado com sucesso!');
        this.loading = false;
        this.closeModal();
        this.openGenerateSuccessModal(orderResult.data.id);
        this.ordersService.updateOrderView();
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openNewOrderModal() {
    this.modalService.dismiss(null);
    this.modalService.present(NewOrderModalComponent);
  }

  openGenerateSuccessModal(orderId: number) {
    this.modalService.dismiss(null);
    this.modalService.present(GenerateInvoiceSuccessModalComponent, orderId);
  }
}
